import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { UPCLAIM_ROLES } from "@upclaim/sdk/src/admin-roles";

import { PortfolioPage } from "@/features/reporting/components/portfolio-page";
import { resolvePeriod } from "@/features/reporting/lib/period";
import { useCurrentUser } from "@/hooks/use-current-user";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/")({
  component: ReportingPortfolioRoute,
});

/**
 * Page par défaut de /reporting. Période et scope viennent du layout. Les clients n'ont pas de
 * période (TECH-1182) : ils lisent tout leur historique.
 */
function ReportingPortfolioRoute() {
  const search = layoutRoute.useSearch();
  const { can } = useCurrentUser();

  return (
    <PortfolioPage
      period={can(UPCLAIM_ROLES) ? resolvePeriod("/reporting", search.period) : "all"}
      filters={{ tenantId: search.tenantId, companyId: search.companyId }}
    />
  );
}
